module.exports = __webpack_public_path__ + "static/media/ico_menu.f071379a.svg";